export const SUGGEST_AGENT_BASED_ON_PAGE_TITLE_ONBOARDING_STATE_KEYS = {
	// Planner
	hasDismissedPlannerOnce: 'suggest-agent-based-on-page-title:hasDismissedPlannerOnce',
	hasDismissedPlannerPermanently:
		'suggest-agent-based-on-page-title:hasDismissedPlannerPermanently',
	hasDismissedDiscoveryAndFeedbackOnce:
		'suggest-agent-based-on-page-title:hasDismissedDiscoveryAndFeedbackOnce',
	hasDismissedDiscoveryAndFeedbackPermanently:
		'suggest-agent-based-on-page-title:hasDismissedDiscoveryAndFeedbackPermanently',
} as const;

export const SuggestAgentBasedOnPageTitleOnboardingKeys = [
	...Object.values(SUGGEST_AGENT_BASED_ON_PAGE_TITLE_ONBOARDING_STATE_KEYS),
] as const;

export const SuggestAgentBasedOnPageTitlePermanentDismissalKeys = [
	SUGGEST_AGENT_BASED_ON_PAGE_TITLE_ONBOARDING_STATE_KEYS.hasDismissedPlannerPermanently,
	SUGGEST_AGENT_BASED_ON_PAGE_TITLE_ONBOARDING_STATE_KEYS.hasDismissedDiscoveryAndFeedbackPermanently,
] as const;
